export const wpBlockButtons = () => {

    const wpBlockButtons = document.querySelectorAll('.wp-block-button.is-style-arrow .wp-block-button__link');

    if (!wpBlockButtons.length) return;

    wpBlockButtons.forEach(button => {
        // Prevent duplicating the circle markup if this runs more than once.
        if (button.querySelector('svg[data-wp-block-buttons-circle="true"]')) return;

        const svgNS = 'http://www.w3.org/2000/svg';

        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('data-wp-block-buttons-circle', 'true');
        svg.setAttribute('viewBox', '0 0 54 54');
        svg.setAttribute('width', '54');
        svg.setAttribute('height', '54');

        const circle = document.createElementNS(svgNS, 'circle');
        circle.setAttribute('cx', '27');
        circle.setAttribute('cy', '27');
        circle.setAttribute('r', '26');
        circle.setAttribute('fill', 'none');
        circle.setAttribute('stroke', 'currentColor');
        circle.setAttribute('stroke-width', '1');
        circle.setAttribute('stroke-dasharray', '170');
        circle.setAttribute('stroke-dashoffset', '170');

        svg.appendChild(circle);
        button.appendChild(svg);
    });

}

